export default "__VITE_ASSET__WWMVMVtq__"